import React from 'react';
import { ZapIcon, ShieldCheckIcon, WrenchIcon } from 'lucide-react';
import { siteConfig } from '../data/config';
import { Pending } from './Pending';
export function TrustLine({
  tone = 'dark'
}: {
  tone?: 'dark' | 'light';
}) {
  const text = tone === 'dark' ? 'text-white/75' : 'text-muted';
  const g = siteConfig.guarantee;
  return <ul className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[9.5px] font-semibold uppercase tracking-[0.03em] ${text}`} data-id="element-193" data-mp="3fzbmjmy70wb5">
      <li className="flex items-center gap-1" data-id="element-194" data-mp="cha7otub6lbh">
        <ZapIcon className="h-2.5 w-2.5 text-gold" aria-hidden="true" data-id="element-195" data-mp="chjvqbvsmiej" />
        {siteConfig.deliveryLabel || <Pending label="Delivery" data-id="element-196" data-mp="7oqsjsfz3i4k" />}
      </li>
      <li className="flex items-center gap-1" data-id="element-197" data-mp="2rgs7hr1pm1y">
        <ShieldCheckIcon className="h-2.5 w-2.5 text-gold" aria-hidden="true" data-id="element-198" data-mp="2qp8b46t9cri" />
        {g.days ? `${g.days}-day money-back guarantee` : <Pending label="Guarantee" data-id="element-199" data-mp="108flz4klp5jo" />}
      </li>
      <li className="flex items-center gap-1" data-id="element-200" data-mp="veuuzwhfdbtz">
        <WrenchIcon className="h-2.5 w-2.5 text-gold" aria-hidden="true" data-id="element-201" data-mp="ve1linr30885" />
        Complete 6-in-1 system
      </li>
    </ul>;
}